import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconLibrary$1 = /*@__PURE__*/ proxyCustomElement(class WppIconLibrary extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-library", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.20087 2.30005H4.05131C4.94752 2.30005 5.68255 2.99434 5.74752 3.87405L5.75219 4.00092V15.907C5.75219 16.8033 5.05789 17.5383 4.17819 17.6033L4.05131 17.6079H3.20087C2.30467 17.6079 1.56964 16.9136 1.50467 16.0339L1.5 15.907V4.00092C1.5 3.10472 2.19429 2.36969 3.074 2.30472L3.20087 2.30005H4.05131H3.20087ZM8.3035 2.30005H9.15394C10.0501 2.30005 10.7852 2.99434 10.8501 3.87405L10.8548 4.00092V15.907C10.8548 16.8033 10.1605 17.5383 9.28082 17.6033L9.15394 17.6079H8.3035C7.40729 17.6079 6.67226 16.9136 6.60729 16.0339L6.60262 15.907V4.00092C6.60262 3.10472 7.29692 2.36969 8.17662 2.30472L8.3035 2.30005H9.15394H8.3035ZM14.2347 4.00135C14.9487 4.00135 15.6024 4.45259 15.842 5.14592L15.882 5.27871L18.4461 15.2679C18.6693 16.1357 18.1797 17.0206 17.3432 17.3019L17.2214 17.3379L16.3974 17.5497C16.2562 17.5854 16.1133 17.6032 15.9739 17.6032C15.2607 17.6032 14.6063 17.1512 14.3673 16.4578L14.3274 16.325L11.7625 6.33665C11.5401 5.46804 12.029 4.58394 12.8661 4.3027L12.988 4.26669L13.8112 4.05493C13.9524 4.01836 14.0952 4.00135 14.2347 4.00135ZM4.05131 3.57571H3.20087C2.99223 3.57571 2.81854 3.72689 2.78251 3.92475L2.77566 4.00092V15.907C2.77566 16.1149 2.92617 16.2892 3.12447 16.3254L3.20087 16.3323H4.05131C4.25995 16.3323 4.43365 16.1811 4.46968 15.9832L4.47653 15.907V4.00092C4.47653 3.79304 4.32601 3.61875 4.12771 3.58259L4.05131 3.57571ZM9.15394 3.57571H8.3035C8.09486 3.57571 7.92116 3.72689 7.88514 3.92475L7.87828 4.00092V15.907C7.87828 16.1149 8.0288 16.2892 8.2271 16.3254L8.3035 16.3323H9.15394C9.36258 16.3323 9.53628 16.1811 9.5723 15.9832L9.57916 15.907V4.00092C9.57916 3.79304 9.42864 3.61875 9.23034 3.58259L9.15394 3.57571ZM14.2356 5.27701L14.1817 5.2803L14.1284 5.29061L13.3052 5.50152C13.1564 5.53979 13.0781 5.64014 13.0441 5.69797C13.0176 5.74287 12.9796 5.82697 12.9851 5.93501L12.9982 6.02029L15.5631 16.0078C15.6192 16.2272 15.8157 16.3276 15.9739 16.3276L16.027 16.3243L16.0802 16.314L16.9042 16.1022C17.1068 16.0508 17.2375 15.861 17.2228 15.6606L17.2104 15.5852L14.6463 5.59592C14.5893 5.37736 14.3937 5.27701 14.2356 5.27701Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-library-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-library", "wpp-icon-library-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-library-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-library-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconLibrary$1);
      }
      break;
  } });
}

const WppIconLibrary = WppIconLibrary$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconLibrary, defineCustomElement };
